import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class GuiaServico extends Servico {
  constructor() {
    super('guia')
  }

  recuperarSequencia(data) {
    store.setCarregando()
    const id = data.id
    return axios
      .get(`${URL}/${this.path}/seq/${id}`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarPorPaciente(guiaId) {
    store.setCarregando()
    return axios
      .get(`${URL}/v2/${this.path}/paciente/${guiaId}`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  enviarParaFaturamento(guiaId, observacao) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}/${guiaId}/bloquear`, { observacao })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  removerDoFaturamento(guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${guiaId}/desbloquear`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  bloquearPagamento(guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${guiaId}/bloquearParaPagamento`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  desbloquearPagamento(guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${guiaId}/desbloquearParaPagamento`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionarEmPacoteFaturamento(guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${guiaId}/adicionaFaturamentoPacote`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  removerDePacoteFaturamento(guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${guiaId}/removeFaturamentoPacote`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionaGuiaFaturada(guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${guiaId}/adicionaGuiaFaturada`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionaGuiaArquivada(guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${guiaId}/adicionaGuiaArquivada`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  adicionaGuiaGlosa(guiaId) {
    store.setCarregando()
    return axios
      .put(`${URL}/${this.path}/${guiaId}/adicionaGuiaGlosa`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarAgendamentos(data) {
    store.setCarregando()
    const guiaId = data.guiaId
    return axios
      .get(`${URL}/${this.path}/${guiaId}/agendamentos`, { params: data })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarAgendamentosTotal(data) {
    store.setCarregando()
    const guiaId = data.guiaId
    return axios
      .get(`${URL}/${this.path}/${guiaId}/agendamentos/total`, { params: data })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  exportarGuia(guiaId, tipo = 'spsadt') {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${guiaId}/pdf?tipo=${tipo}`, {
        responseType: 'blob',
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  retornarQuantidadeDeAgendamentosRestantes(agendamentoId) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${agendamentoId}/agendamentosRestantes`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  verificaSePrimeiroAgendamentoDaGuia(agendamentoId) {
    store.setCarregando()
    return axios
      .get(`${URL}/agenda/${agendamentoId}/guiasAvaliacao`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  validarPendenciaDeMateriaisPorId(guiaId) {
    return this.recuperarAgendamentos({
      guiaId: guiaId,
      limit: 10,
    }).then((response) => {
      return this.validarPendenciaDeMateriais(response.agendamentos)
    })
  }

  validarPendenciaDeMateriais(agendamentosDaGuia) {
    const agendamentos = [...(agendamentosDaGuia || [])]

    const agendamentosOrdenados = agendamentos.sort(
      (a, b) => new Date(b.data) - new Date(a.data)
    )

    const quatroPrimeirasAssinadas = agendamentosOrdenados
      .slice(0, 4)
      .every((a) => a.status === 'assinado' || a.status === 'evoluido')

    const quintaAssinada =
      (agendamentosOrdenados[4] &&
        (agendamentosOrdenados[4].status === 'assinado' ||
          agendamentosOrdenados[4].status === 'evoluido')) ??
      false

    const novePrimeirasAssinadas = agendamentosOrdenados
      .slice(0, 9)
      .every((a) => a.status === 'assinado' || a.status === 'evoluido')

    const decimaAssinada =
      (agendamentosOrdenados[9] &&
        (agendamentosOrdenados[9].status === 'assinado' ||
          agendamentosOrdenados[9].status === 'evoluido')) ??
      false

    return (
      (quatroPrimeirasAssinadas && !quintaAssinada) ||
      (novePrimeirasAssinadas && !decimaAssinada)
    )
  }
}

export default GuiaServico
